import { render } from "./OperatorEditForm.vue?vue&type=template&id=51cabbea"
import script from "./OperatorEditForm.vue?vue&type=script&lang=ts"
export * from "./OperatorEditForm.vue?vue&type=script&lang=ts"

import "./OperatorEditForm.vue?vue&type=style&index=0&id=51cabbea&lang=scss"
script.render = render

export default script